<template>
  <v-card tile>
    <v-card-title>
      <v-row>
        <v-col cols="2">
          <v-checkbox v-model="allCourses" label="Tous les cours" @change="getDataFromApi()"></v-checkbox>
        </v-col>
        <v-col cols="2">
          <v-select
            :items="possibleStatuses"
            item-text="text"
            item-value="value"
            v-model="status"
            menu-props="auto"
            label="Absences"
            hide-details
            @change="getDataFromApi()"
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
            :items="possibleCheckinTypes"
            item-text="text"
            item-value="value"
            v-model="checkinType"
            menu-props="auto"
            label="Retards / départs"
            hide-details
            @change="getDataFromApi()"
          ></v-select>
        </v-col>
        <v-col cols="auto">
          <v-dialog ref="dialog" v-model="dialog" persistent width="900">
            <template v-slot:activator="{ on }">
              <div v-on="on" class="date-selector">
                <template v-if="dates && dates[0] && dates[1]">
                  <v-icon small color="green darken-1" class="mr-1">mdi-calendar-start</v-icon>
                  <span class="text-no-wrap">{{ dates[0] | dateToHuman }}</span>
                  <v-icon small class="mx-2">mdi-arrow-right</v-icon>
                  <v-icon small color="red darken-1" class="mr-1">mdi-calendar-end</v-icon>
                  <span class="text-no-wrap">{{ dates[1] | dateToHuman }}</span>
                </template>
                <span v-else class="grey--text text-caption">Sélectionner une période</span>
              </div>
            </template>
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-list dense>
                      <v-subheader>Preset</v-subheader>
                      <v-list-item-group color="primary">
                        <v-list-item
                          v-for="preset in date_presets"
                          :key="preset.label"
                          @click="onDateRangeChange(preset.range)"
                        >
                          <v-list-item-content>
                            <v-list-item-title v-text="preset.label"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-col>
                  <v-col cols="12" md="9">
                    <v-date-picker
                      v-model="dates"
                      range
                      locale="fr-CH"
                      first-day-of-week="1"
                      @input="onDateRangeChange"
                    ></v-date-picker>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dialog = false">Annuler</v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="
                    dialog = false
                    getDataFromApi()
                  "
                >
                  OK
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Chercher"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-title>
    <v-data-table
      class="short-table"
      :headers="headers"
      :items="presences"
      :loading="loading"
      :items-per-page="200"
      :search="search"
      :custom-filter="customFilter"
      item-key="id"
      :footer-props="{
        itemsPerPageText: 'Nombre de lignes',
        pageText: 'Lignes {0}-{1} de {2}',
      }"
    >
      <template v-slot:progress>
        <v-progress-linear color="primary" indeterminate />
      </template>
      <template v-slot:body="{ items }">
        <tbody v-if="!loading">
          <tr
            v-for="item in items"
            :key="(item.isCheckin ? 'checkin-' : 'presence-') + item.id"
            @click="navigateToStudent(item.student_course?.student)"
            class="clickable"
          >
            <td>{{ item.student_course?.course?.name }}</td>
            <td>{{ item.statut }}</td>
            <td>{{ item.comment }}</td>
            <td :class="{ red: item.longAbsence }">
              {{ item.student_course?.student?.last_name }}
            </td>
            <td>{{ item.student_course?.student?.first_name }}</td>
            <td>{{ item.date | dateToHuman }}</td>
            <td>{{ item.student_course?.student?.mobile }}</td>
            <td>{{ item.student_course?.student?.email }}</td>
            <td v-if="isAdmin" @click="deleteItem(item)">
              <v-btn text icon color="red">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import { date_presets } from "@/utils/helpers.js"
import Presence from "@/models/Presence"
import Checkin from "@/models/Checkin"
import Course from "@/models/Course"
import StudentCourse from "@/models/StudentCourse"
import { dateToHuman } from "@/services/utils.js"
import { mapGetters } from "vuex"

export default {
  data() {
    return {
      headers: [
        { text: "Nom du cours", value: "student_course.course.name" },
        { text: "Présences", value: "statut" },
        { text: "Justification", value: "comment" },
        { text: "Nom", value: "student_course?.student.last_name" },
        { text: "Prénom", value: "student_course?.student.first_name" },
        { text: "Date", value: "date" },
        { text: "Mobile", value: "student_course?.student.mobile" },
        { text: "Email", value: "student_course?.student.email" },
      ],
      status: "tout",
      checkinType: "tout",
      allCourses: false,
      date: "",
      dates: [
        new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toLocaleDateString("en-CA"),
        new Date().toLocaleDateString("en-CA"),
      ],
      date_presets,
      dialog: false,
      formTitle: "Ouvrir un nouveau cours",
      search: "",
      loading: true,
      presences: [],
    }
  },
  async mounted() {
    this.loading = true
    await this.getDataFromApi()
  },
  computed: {
    ...mapGetters("Auth", ["isAdmin"]),
    possibleStatuses() {
      return Presence.statuts(true, this.isAdmin)
    },
    possibleCheckinTypes() {
      return Checkin.types(true)
    },
    computedDates() {
      // if there is no second date, return first date twice
      return this.dates.length == 1 ? [this.dates[0], this.dates[0]] : this.dates
    },
    formattedDates() {
      return `${dateToHuman(this.computedDates[0])} - ${dateToHuman(this.computedDates[1])}`
    },
  },
  methods: {
    /** check if absence is more than in one week */
    addLongAbsence() {
      const absences = this.presences.filter((e) => !e.isCheckin)
      if (absences.length > 0) {
        const lookup = absences.reduce((accumulator, currentValue) => {
          accumulator[currentValue?.student_course?.student_id] =
            ++accumulator[currentValue?.student_course?.student_id] || 0
          return accumulator
        }, {})

        absences
          .filter((e) => lookup[e?.student_course?.student_id])
          .forEach((duplicate) => (duplicate.longAbsence = true))
      }
    },
    addEvamCodes() {
      this.presences.forEach((presence) => {
        if (presence?.student_course?.student?.assistant?.mandat === "EVAM") {
          presence.statut = presence.statut + presence.evamCode
        }
      })
    },
    onDateRangeChange(t) {
      t.sort((a, b) => Date.parse(a) - Date.parse(b))
      this.dates = t
    },
    deleteItem(item) {
      if (!confirm("Are you sure you want to delete this item?")) return
      const request = item.isCheckin ? Checkin.deleteOne(item.id) : Presence.deleteOne(item.id)
      request.then(() => this.getDataFromApi())
    },
    /**
     * Both dropdowns on "tout" show both record types merged. A specific value in one
     * dropdown (the other on "tout") narrows to that record type. Both specific shows
     * both record types, each filtered to its selected value.
     */
    showAbsences() {
      return this.status !== "tout" || this.checkinType === "tout"
    },
    showCheckins() {
      return this.checkinType !== "tout" || this.status === "tout"
    },
    async getDataFromApi() {
      this.loading = true
      Presence.deleteAll()
      Checkin.deleteAll()

      let promises = []

      const courses = Course.query().all()
      if (!courses.length) {
        promises.push(Course.get())
      }

      promises.push(StudentCourse.getStudentCoursesBetweenDates(this.computedDates[0], this.computedDates[1]))
      if (this.showAbsences()) {
        promises.push(
          Presence.getPresencesBetweenDates(this.computedDates[0], this.computedDates[1], this.status, !this.allCourses)
        )
      }
      if (this.showCheckins()) {
        promises.push(
          Checkin.getCheckinsBetweenDates(this.computedDates[0], this.computedDates[1], this.checkinType, !this.allCourses)
        )
      }

      await Promise.all(promises)

      const absences = !this.showAbsences()
        ? []
        : Presence.query()
            .where((p) => {
              return (
                p.date >= this.computedDates[0] &&
                p.date <= this.computedDates[1] &&
                (this.status == "tout" || p.statut == this.status)
              )
            })
            .with("student_course", (query) => {
              query.with("student").with("course")
            })
            .get()

      const checkins = !this.showCheckins()
        ? []
        : Checkin.query()
            .where((c) => {
              return (
                c.date >= this.computedDates[0] &&
                c.date <= this.computedDates[1] &&
                (this.checkinType == "tout" || c.type == this.checkinType)
              )
            })
            .with("student_course", (query) => {
              query.with("student").with("course")
            })
            .get()

      checkins.forEach((c) => {
        c.isCheckin = true
        c.statut = c.statusLabel
      })

      this.presences = [...absences, ...checkins].sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0))

      this.addLongAbsence()
      this.addEvamCodes()
      this.loading = false
    },
    customFilter(value, search, item) {
      if (!search) return true
      const s = search.toLowerCase()
      return [
        item.student_course?.course?.name,
        item.statut,
        item.comment,
        item.student_course?.student?.last_name,
        item.student_course?.student?.first_name,
        item.date,
        item.student_course?.student?.mobile,
        item.student_course?.student?.email,
      ].some((v) => v && String(v).toLowerCase().includes(s))
    },
    navigateToStudent(student) {
      if (!student) return
      this.$router.push(`/students/${student.id}`)
    },
  },
}
</script>
<style>
.v-input__slot {
  margin-bottom: 0;
}
.v-text-field__details {
  height: 0px !important;
}
.short-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}

.v-picker__title {
  display: none;
}
.clickable {
  cursor: pointer;
}

.date-selector {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.2s ease;
  width: fit-content;
  font-size: 14px;
}

.date-selector:hover {
  border-color: rgba(0, 0, 0, 0.87);
}
</style>
